import {IServiceFactory} from "../../../../service-factory.interface";
import {MealSsrBase} from "../meal-ssr-base";

//Meniu Chiftelute cu sos rosu, piure de cartofi si fasole verde
export default class HfmlSsrType extends MealSsrBase {
    constructor(services: IServiceFactory) {
        super('HFML', services);
    }
}
